module.exports = __webpack_public_path__ + "static/media/downFilter.c421cb32.svg";